module.exports = __webpack_public_path__ + "static/media/Error.d4573ff5.svg";